var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M64 112c26.5 0 48-21.5 48-48S90.5 16 64 16 16 37.5 16 64s21.5 48 48 48zm0 288c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0-192c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }